import { Directive, HostListener, ElementRef, inject } from '@angular/core';

@Directive({
  selector: 'input[digitsOnly]',
})
export class DigitsOnlyDirective {
  private el = inject(ElementRef)

  @HostListener('input', ['$event.target.value'])
  onInputChange(value: string) {
    this.el.nativeElement.value = value.replace(/[^0-9]/g, '');
  }
}